import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import DarkBg from '@/components/dark-bg.vue';
import quitDialog from './components/quitDialog.vue';
import LoadingMusk from './components/loadingMusk.vue';
import { getExpSubjectList as _getExpSubjectList, getExpBoxList, getProductDesc as _getProductDesc, accountExpStart, managerExpReady, accountExpExist as _accountExpExist } from '@/api/modules/select';
import { mapGetters } from 'vuex'; // import polling from '@/utils/polling-utils'

import { deepCody, debounce } from '@/utils/tools/index.js';
export default {
  name: 'Select',
  components: {
    DarkBg: DarkBg,
    quitDialog: quitDialog,
    LoadingMusk: LoadingMusk
  },
  data: function data() {
    return {
      subjectData: null,
      // 学科与年级列表
      boxList: null,
      // 左侧书列表
      showQuitDialog: false,
      // 退出弹窗
      curGradeId: null,
      // 当前选中的年级Id
      curSubjectId: null,
      // 当前选中的学科Id
      curBoxParams: {
        // 当前选中的书本信息参数
        libraryId: '',
        phone: '',
        shelvesType: false
      },
      curBoxParams_temp: {
        // 当前选中的书本信息参数 _ 临时保存
        libraryId: '',
        phone: '',
        shelvesType: false
      },
      boxDesc: null,
      // 书本url集合
      pollingPt: null,
      // 轮询定时器
      readyLoadingStatus: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['experienceBook'])), {}, {
    showButton: function showButton() {
      return this.curBoxParams_temp.shelvesType;
    }
  }),
  watch: {
    // 监听书本参数
    curBoxParams: {
      handler: function handler(newVal, oldVal) {
        if ((newVal === null || newVal === void 0 ? void 0 : newVal.libraryId) === (oldVal === null || oldVal === void 0 ? void 0 : oldVal.libraryId)) return;
        var d = this.getExperienceBookData(newVal);
        this.$store.dispatch('setExperienceBook', d);
      },
      deep: true
    }
  },
  destroyed: function destroyed() {
    this.stopTimeOut();
    window.removeEventListener('resize', this.updateScrollBar);
  },
  mounted: function mounted() {
    this.accountExpExist();
    this.watchResize();
  },
  methods: {
    watchResize: function watchResize() {
      window.addEventListener('resize', debounce(this.updateScrollBar, 2000));
    },
    updateScrollBar: function updateScrollBar() {
      var _this$$refs, _this$$refs$scrollbar;

      (_this$$refs = this.$refs) === null || _this$$refs === void 0 ? void 0 : (_this$$refs$scrollbar = _this$$refs.scrollbar) === null || _this$$refs$scrollbar === void 0 ? void 0 : _this$$refs$scrollbar.update();
    },
    // 判断是否登录过体验模式
    accountExpExist: function accountExpExist() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$_accountExpExi, status, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _accountExpExist();

              case 2:
                _yield$_accountExpExi = _context.sent;
                status = _yield$_accountExpExi.status;
                data = _yield$_accountExpExi.data;

                // 跳过产品选择，直接进入体验指南页
                if (status === 1 && data !== null && data !== void 0 && data.libraryId && data !== null && data !== void 0 && data.phone) {
                  _this.curBoxParams_temp.libraryId = data.libraryId;
                  _this.curBoxParams_temp.phone = data.phone;
                  _this.curBoxParams = deepCody(_this.curBoxParams_temp);

                  _this.toExperience();
                } else {
                  _this.getExpSubjectList();
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 获取年级学科列表
    getExpSubjectList: function getExpSubjectList() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$_getExpSubject, status, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _getExpSubjectList();

              case 3:
                _yield$_getExpSubject = _context2.sent;
                status = _yield$_getExpSubject.status;
                data = _yield$_getExpSubject.data;

                if (status === 1) {
                  _this2.subjectData = data;
                  _this2.curGradeId = _this2.subjectData.grade[0].id;
                  _this2.curSubjectId = _this2.subjectData.subject[0].id;

                  _this2.getBoxList();
                } else {
                  console.log('请求年级学科列表失败');
                }

                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);
                console.error(_context2.t0);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 9]]);
      }))();
    },
    getExperienceBookData: function getExperienceBookData(newVal) {
      var localCurBoxParams = deepCody(this.experienceBook);
      var merge = Object.assign(localCurBoxParams, newVal);
      var d = Object.assign(merge, {
        subjectId: this.curSubjectId
      });
      return d;
    },
    // 选择年级
    chooseGrade: function chooseGrade(g) {
      if (this.curGradeId === g.id) return;
      this.curGradeId = g.id;
      this.getBoxList();
    },
    // 选择学科
    chooseSubject: function chooseSubject(s) {
      if (this.curSubjectId === s.id) return;
      this.curSubjectId = s.id;
      this.getBoxList();
    },
    // 选择书
    chooseBox: function chooseBox(b) {
      var _this$curBoxParams_te;

      if (b.libraryId === ((_this$curBoxParams_te = this.curBoxParams_temp) === null || _this$curBoxParams_te === void 0 ? void 0 : _this$curBoxParams_te.libraryId)) return;
      this.curBoxParams_temp.libraryId = b.libraryId;
      this.getProductDesc();
    },
    // 获取boxList
    getBoxList: function getBoxList() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var curSubjectId, curGradeId, _yield$getExpBoxList, status, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.resetShelvesType();

                curSubjectId = _this3.curSubjectId, curGradeId = _this3.curGradeId;
                _context3.prev = 2;
                _context3.next = 5;
                return getExpBoxList({
                  subjectId: curSubjectId,
                  gradeId: curGradeId
                });

              case 5:
                _yield$getExpBoxList = _context3.sent;
                status = _yield$getExpBoxList.status;
                data = _yield$getExpBoxList.data;

                if (status === 1) {
                  _this3.boxList = data;

                  if (data.length > 0) {
                    _this3.curBoxParams_temp.libraryId = data[0].libraryId;

                    _this3.getProductDesc();
                  }
                }

                _context3.next = 14;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3["catch"](2);
                console.error(_context3.t0);

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[2, 11]]);
      }))();
    },
    // 获取右侧产品介绍
    getProductDesc: function getProductDesc() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var libraryId, _yield$_getProductDes, status, data;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // 重置数据
                _this4.resetShelvesType();

                _this4.boxDesc = null;
                libraryId = _this4.curBoxParams_temp.libraryId;

                if (libraryId) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt("return");

              case 5:
                _context4.prev = 5;
                _context4.next = 8;
                return _getProductDesc({
                  libraryId: libraryId
                });

              case 8:
                _yield$_getProductDes = _context4.sent;
                status = _yield$_getProductDes.status;
                data = _yield$_getProductDes.data;

                if (status === 1) {
                  _this4.boxDesc = data;
                  _this4.curBoxParams_temp.shelvesType = data.shelvesType;
                  _this4.curBoxParams_temp.phone = data.phone;

                  if (data.shelvesType) {
                    _this4.setFooterStyle();
                  }
                }

                _context4.next = 17;
                break;

              case 14:
                _context4.prev = 14;
                _context4.t0 = _context4["catch"](5);
                console.error(_context4.t0);

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[5, 14]]);
      }))();
    },
    // 开始免费体验
    toExperience: function toExperience() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _this5$curBoxParams_t, libraryId, phone, _yield$accountExpStar, status, data;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.readyLoadingStatus = true; // 缓存subject到vuex

                _this5.$store.dispatch('setSubject', _this5.curSubjectId);

                _this5$curBoxParams_t = _this5.curBoxParams_temp, libraryId = _this5$curBoxParams_t.libraryId, phone = _this5$curBoxParams_t.phone;
                _context5.prev = 3;
                _context5.next = 6;
                return accountExpStart({
                  libraryId: libraryId,
                  phone: String(phone)
                });

              case 6:
                _yield$accountExpStar = _context5.sent;
                status = _yield$accountExpStar.status;
                data = _yield$accountExpStar.data;

                if (!(status !== 1)) {
                  _context5.next = 12;
                  break;
                }

                _this5.readyLoadingStatus = false;
                return _context5.abrupt("return");

              case 12:
                data.ready ? _this5.toIndexPage() : _this5.pollingReady();
                _context5.next = 18;
                break;

              case 15:
                _context5.prev = 15;
                _context5.t0 = _context5["catch"](3);
                console.error(_context5.t0);

              case 18:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[3, 15]]);
      }))();
    },
    toIndexPage: function toIndexPage() {
      var _this6 = this;

      this.curBoxParams = deepCody(this.curBoxParams_temp);
      this.readyLoadingStatus = false; // 设置成体验模式

      this.$store.dispatch('setUserMode', 'experience');
      setTimeout(function () {
        _this6.$router.push('/');
      }, 0);
    },
    getReady: /*#__PURE__*/regeneratorRuntime.mark(function getReady() {
      return regeneratorRuntime.wrap(function getReady$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return managerExpReady();

            case 2:
            case "end":
              return _context6.stop();
          }
        }
      }, getReady);
    }),
    // 轮询体验数据是否复制成功
    pollingReady: function pollingReady() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _yield$_this7$getRead, status, data;

        return regeneratorRuntime.wrap(function _callee6$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return _this7.getReady().next().value;

              case 3:
                _yield$_this7$getRead = _context7.sent;
                status = _yield$_this7$getRead.status;
                data = _yield$_this7$getRead.data;

                if (status === 1) {
                  if (data) {
                    _this7.toIndexPage();
                  } else {
                    _this7.pollingPt = setTimeout(_this7.pollingReady, 5000);
                  }
                } else {
                  _this7.readyLoadingStatus = false;
                }

                _context7.next = 13;
                break;

              case 9:
                _context7.prev = 9;
                _context7.t0 = _context7["catch"](0);
                _this7.readyLoadingStatus = false;
                console.error(_context7.t0);

              case 13:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee6, null, [[0, 9]]);
      }))();
    },
    // async pollingReady() {
    //   const { status, data } = await polling(managerExpReady, {}, 3000)
    //   if (status === 1 && data) {
    //     this.toIndexPage()
    //   }
    // },
    logOut: function logOut() {
      this.showQuitDialog = true;
    },
    stopTimeOut: function stopTimeOut() {
      this.pollingPt && clearTimeout(this.pollingPt);
    },
    resetShelvesType: function resetShelvesType() {
      this.curBoxParams_temp.shelvesType = false;
    },
    // 设置底部button左侧坐标。
    setFooterStyle: function setFooterStyle() {
      this.$nextTick(function () {
        var d = document.querySelector('.select_box_desc');
        var b = document.querySelector('.select-footer');
        var leftToBody = d === null || d === void 0 ? void 0 : d.getBoundingClientRect().left;
        var l = leftToBody + (d.clientWidth - b.clientWidth) / 2;
        b.style.left = l + 'px';
      });
    }
  }
};